<div class="container">
  <mat-card>
    <mat-card-header>
      <div class="page-title">EPA</div>
    </mat-card-header>

    <mat-card-content class="pt-16">
      <form #downloadForm="ngForm" (ngSubmit)="onAction()" class="epa-form">
        <grid-input
          [placeholder]="'005-058-2025-000000001'"
          grid-tab-index="0"
          showClear="false"
          name="docId"
          [(ngModel)]="documentId"
          (ngModelChange)="onDocumentIdChange()"
        >
          <span slot="description">Claim number</span>
        </grid-input>

        <div class="input-hint" *ngIf="isPartialClaimNumber">
          <grid-icon name="information-circle-outline" size="m"></grid-icon>
          <span>Codice agenzia non rilevato — verranno mostrati i sinistri disponibili</span>
        </div>

        <mat-card-actions class="actions-right">
          <div class="download-btn-wrapper ml-1.5">
            <grid-button
              [gridDisabled]="isActionDisabled"
              type="button"
              variant="secondary"
              (click)="onAction()"
            >
              {{ actionButtonLabel }}
            </grid-button>
          </div>
        </mat-card-actions>
      </form>

      <!-- ───── Claims list section ───── -->
      <epa-section
        *ngIf="claimsList.length > 0"
        title="Sinistri disponibili"
        [subtitle]="claimsList.length + (claimsList.length !== 1 ? ' sinistri trovati' : ' sinistro trovato') + ' — seleziona per avviare il download'"
        iconName="folder-open-outline"
        variant="red"
      >
        <epa-item-card
          *ngFor="let claim of claimsList; let i = index"
          [style.animation-delay]="(i * 60) + 'ms'"
          label="Numero sinistro"
          [value]="claim"
          actionIconName="cloud-download-outline"
          actionLabel="Scarica"
          [clickable]="true"
          variant="red"
          (cardClick)="selezionaSinistro($event)"
        ></epa-item-card>
      </epa-section>

      <!-- ───── Documents found section ───── -->
      <epa-section
        *ngIf="documentsFound.length > 0"
        [title]="'Documenti nel file zip (' + documentsFound.length + ')'"
        subtitle="Questi documenti sono stati inseriti nel file zip"
        iconName="checkmark-circle-outline"
        variant="green"
        [collapsible]="true"
      >
        <epa-item-card
          *ngFor="let doc of documentsFound"
          [value]="doc"
          variant="green"
        ></epa-item-card>
      </epa-section>

      <!-- ───── Documents not found section ───── -->
      <epa-section
        *ngIf="documentsNotFound.length > 0"
        [title]="'Documenti non trovati (' + documentsNotFound.length + ')'"
        subtitle="Non è stato possibile scaricare i seguenti documenti"
        iconName="alert-circle-outline"
        variant="red"
        [collapsible]="true"
      >
        <epa-item-card
          *ngFor="let doc of documentsNotFound"
          [value]="doc"
          variant="red"
        ></epa-item-card>
      </epa-section>

    </mat-card-content>
  </mat-card>
</div>
